import {
  clearState,
  createEmptyLoadingState,
  createErrorState,
  createLoadingState,
  createSuccessState,
  emptyRequestStatus,
} from 'app/store/app/app.models';
import {
  DlqActionTypes,
  DlqActions
} from 'app/store/dlq/dlq.actions';
import {
  IDlqState,
  initialDlqState
} from 'app/store/dlq/dlq.state'

export function dlqReducers(
  state = initialDlqState,
  action: DlqActions): IDlqState {
    switch (action.type) {
      case DlqActionTypes.FETCH_DLQ_MESSAGES:
        return {
          ...state,
          loading: true,
          error: null,
          pagination: {
            pageNumber: action.payload.pageNumber ?? state.pagination.pageNumber,
            pageSize: action.payload.pageSize ?? state.pagination.pageSize,
          },
          sortDescriptors: action.payload.sortDescriptors ?? state.sortDescriptors,
          messageDeleted: false,
          multiDeleteSuccess: false,
          multiDeleteError: null,
          deleteError: null,
          redriveError: null,
          approveError: null,
          approveSuccess: false,
          submitNewMessageSuccess: false,
          submitNewMessageError: null,
        };
      case DlqActionTypes.FETCH_DLQ_MESSAGES_SUCCESS:
        return {
          ...state,
          messages: action.payload.messages ?? state.messages,
          totalMessageCount: action.payload.totalMessageCount ?? state.totalMessageCount,
          loading: false,
          error: null,
        };
      case DlqActionTypes.FETCH_DLQ_MESSAGES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          totalMessageCount: 0,
          messages: [],
        };
      case DlqActionTypes.FETCH_DLQ_MESSAGE_BY_ID:
        return {
          ...state,
          loading: true,
          error: null,
          approveSuccess: false,
          approveError: null,
          submitNewMessageSuccess: false,
          messageDeleted: false,
          multiDeleteSuccess: false,
          multiDeleteError: null,
        };
      case DlqActionTypes.FETCH_DLQ_MESSAGE_BY_ID_SUCCESS:
        return {
          ...state,
          message: action.payload.message,
          loading: false,
          error: null,
        };
      case DlqActionTypes.FETCH_DLQ_MESSAGE_BY_ID_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error,
        };
      case DlqActionTypes.DELETE_MULTIPLE_DLQ_MESSAGES_SUCCESS:
        return {
          ...state,
          loading: false,
          multiDeleteError: null,
          multiDeleteSuccess: true,
        }
      case DlqActionTypes.DELETE_DLQ_MESSAGE_BY_ID_SUCCESS:
        return {
          ...state,
          loading: false,
          deleteError: null,
          message: {},
          messageDeleted: true,
        };
      case DlqActionTypes.DELETE_MULTIPLE_DLQ_MESSAGES:
      case DlqActionTypes.DELETE_DLQ_MESSAGE_BY_ID:
        return {
          ...state,
          loading: true,
          error: null,
          messageDeleted: false,
          deleteError: null,
        };
      case DlqActionTypes.DELETE_MULTIPLE_DLQ_MESSAGES_FAILURE:
        return {
          ...state,
          loading: false,
          multiDeleteError: action.payload.error,
          multiDeleteSuccess: false,
        }
      case DlqActionTypes.DELETE_DLQ_MESSAGE_BY_ID_FAILURE:
        return {
          ...state,
          loading: false,
          deleteError: action.payload.error,
        };
      case DlqActionTypes.REDRIVE_DLQ_MESSAGE_BY_ID:
        return {
          ...state,
          loading: true,
          redriveError: null,
        };
      case DlqActionTypes.REDRIVE_DLQ_MESSAGE_BY_ID_SUCCESS:
        return {
          ...state,
          loading: false,
          redriveError: null,
          message: action.payload.message,
        };
      case DlqActionTypes.REDRIVE_DLQ_MESSAGE_BY_ID_FAILURE:
        return {
          ...state,
          loading: false,
          redriveError: action.payload.error,
        };
      case DlqActionTypes.APPROVE_DLQ_MESSAGE:
        return {
          ...state,
          loading: true,
          approveError: null,
          approveSuccess: false,
        };
      case DlqActionTypes.APPROVE_DLQ_MESSAGE_SUCCESS:
        return {
          ...state,
          loading: false,
          approveError: null,
          approveSuccess: true,
        };
      case DlqActionTypes.APPROVE_DLQ_MESSAGE_FAILURE:
        return {
          ...state,
          loading: false,
          approveError: action.payload.error,
          approveSuccess: false,
        };
      case DlqActionTypes.SUBMIT_MESSAGE_FOR_REVIEW:
      case DlqActionTypes.SUBMIT_NEW_DLQ_MESSAGE:
        return {
          ...state,
          loading: true,
          submitNewMessageError: null,
          submitNewMessageSuccess: false,
        };
      case DlqActionTypes.SUBMIT_MESSAGE_FOR_REVIEW_SUCCESS:
      case DlqActionTypes.SUBMIT_NEW_DLQ_MESSAGE_SUCCESS:
        return {
          ...state,
          loading: false,
          submitNewMessageSuccess: true,
          submitNewMessageError: null,
        };
      case DlqActionTypes.SUBMIT_MESSAGE_FOR_REVIEW_FAILURE:
      case DlqActionTypes.SUBMIT_NEW_DLQ_MESSAGE_FAILURE:
        return {
          ...state,
          loading: false,
          submitNewMessageError: action.payload.error,
          submitNewMessageSuccess: false,
        };
      default:
        return state;
    }
  }
